import instance from '../instance';
import getIframePositionForElement from '../utils/helpers/get-iframe-position-for-element';

const getElementStyles = (liveElement) => {
  const liveDocument = instance.driver.getLiveDocument();
  const styles = liveDocument.defaultView.getComputedStyle(liveElement);
  const { left, right, width, height, top, bottom } = liveElement.getBoundingClientRect();
  const { top: parentIframeTop } = getIframePositionForElement(liveElement);
  return {
    elPaddingTop: parseFloat(styles.paddingTop, 10),
    elBorderTop: parseFloat(styles.borderTopWidth, 10),
    elLeft: left,
    elRight: right,
    elWidth: width,
    elHeight: height,
    elTop: parentIframeTop + top,
    elBottom: parentIframeTop + bottom,
    elOffsetTop: liveElement.offsetTop,
  };
};

export default getElementStyles;
